import { SiteData } from '~/data/clevertap/clevertap'

export interface JBClevertapSiteData extends SiteData {
  Identity: string
  Email: string
  Name: string
  Phone: string
  Gender?: 'M' | 'F'
  DOB?: Date
  'MSG-email': boolean
  'MSG-whatsapp': boolean
  'MSG-sms': boolean
  CreationSource: string
  AcquisitionSource?: string | null
  StateOfResidence?: string
  CityOfResidence?: string
  IncomeSource?: string
  EducationLevel?: string
  IsAnnotated?: boolean
  MonthlyIncome?: number
  QuodScore?: number
}

export interface JBClevertapProfileData {
  Site: JBClevertapSiteData
}

export interface JBClevertapEventData {
  eventName: JbClevertapEvent
  eventData?: any
}

export enum JbClevertapEvent {
  USER_CREATED = 'User Created',
  USER_LOGGED_IN = 'User LoggedIn',
  LOAN_SIMULATION = 'Loan Simulation',
  AFFILIATE_OFFER_SELECTED = 'Affiliate Offer Selected',
  AFFILIATE_OFFER_REDIRECT = 'Affiliate Offer Redirect',
  BUTTON_CLICK = 'Button Click',
  MODAL_DISPLAYED = 'Modal Displayed',
  PAGE_VIEW = 'Page View',
}

export interface JbUserCreatedEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.USER_CREATED
  eventData: {
    utm_source?: string
    utm_medium?: string
    utm_campaign?: string
    Platform?: string
  }
}

export interface JbUserLoggedInEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.USER_LOGGED_IN
  eventData: {
    utm_source?: string
    utm_medium?: string
    utm_campaign?: string
    utm_product?: string
    Platform?: string
  }
}

export interface JbLoanSimulationEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.LOAN_SIMULATION
  eventData: {
    ProductName: string
    LoanAmount: number
    LoanInstallments: number
    Platform: string
  }
}

export interface JbAffiliateOfferSelectedEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.AFFILIATE_OFFER_SELECTED
  eventData: {
    ProductName: string
    CompanyName: string
    RedirectURL: string
    Platform: string
  }
}

export interface JbAffiliateOfferRedirectEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.AFFILIATE_OFFER_REDIRECT
  eventData: {
    ProductName: string
    CompanyName: string
    RedirectURL: string
    Platform: string
  }
}

export interface JbButtonClickEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.BUTTON_CLICK
  eventData: {
    Product: string
    ButtonText: string
    URL: string
    Platform: string
  }
}

export interface JbModalDisplayedEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.MODAL_DISPLAYED
  eventData: {
    URL: string
    Product: string
    Context: string
  }
}

export interface JbPageViewEvent extends JBClevertapEventData {
  eventName: JbClevertapEvent.PAGE_VIEW
  eventData: {
    URL: string
    Platform: string
  }
}
